import React from "react";

const TradePartnerIcon = (props) => {
    let height = props?.height ? props?.height : 20;
    let width = props?.width ? props?.width : 20;

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            width={width}
            height={height}
            viewBox="0 0 512 512"
        >
            <g fill="currentColor">
                {/* Left entity */}
                <circle cx="120" cy="160" r="48" />
                <rect x="70" y="220" width="100" height="140" rx="20" />

                {/* Right entity */}
                <circle cx="392" cy="160" r="48" />
                <rect x="342" y="220" width="100" height="140" rx="20" />

                {/* Exchange arrows */}
                <path d="M170 260h140l-30-30a12 12 0 1 1 17-17l50 50-50 50a12 12 0 1 1-17-17l30-30H170a12 12 0 0 1 0-24z" />
                <path d="M342 320H202l30 30a12 12 0 1 1-17 17l-50-50 50-50a12 12 0 1 1 17 17l-30 30h140a12 12 0 0 1 0 24z" />

                {/* Ledger base line */}
                <rect x="80" y="380" width="352" height="20" rx="10" opacity="0.5" />
            </g>
        </svg>
    );
};

export default TradePartnerIcon;